angular.module('app').directive('apSaveStringToFile',
    ['BrowserService',
        function (BrowserService) {
            'use strict';

            function link($scope, element) {
                function _saveTextAsFile(fileNameToSaveAs, textToWrite) {

                    if (!BrowserService.isBlobCompatible) {
                        return;
                    }

                    var textFileAsBlob = new Blob([textToWrite], {
                        type: 'text/html; charset=utf-8'
                    });

                    BrowserService.saveBlob(document, textFileAsBlob, fileNameToSaveAs);
                }

                function _onClick() {
                    $scope.loadText()
                        .then(function (data) {
                            if (data) {
                                _saveTextAsFile($scope.fileName, data);
                            }
                        });
                }

                element.on('click', _onClick);
                $scope.$on('$destroy', function () {
                    element.off('click');
                });
            }

            return {
                restrict: 'A',
                scope: {
                    loadText: '&apSaveStringToFile',
                    fileName: '@'
                },
                link: link
            };
        }]);